import type { API } from 'chessboard/api/config/types';
import type JCE from '@chesscom/js-chess-engine';
import { getExtendedNode } from 'chessboard/model/game/get-extended-node';

/**
 * Create the getLastMove method.
 */
export function createGetLastMove(context: API.Context) {
  /**
   * Get a verbose object representing the last move made in the game.
   */
  return function getLastMove(): JCE.Node.Model | undefined {
    const { game } = context;

    return (
      getExtendedNode({
        move: game.history(true).slice(-1)[0],
        startingMoveNumber: game.startingMoveNumber(),
      }) ?? undefined
    );
  };
}
